const apiKeys = {
  headerButtons: {
    create: 'Create',
  },
  table: {
    headers: {
      alias: 'Name',
      createdAt: 'Created At',
      accessTokenExpiration: 'Session Expiration',
      permissions: 'Permissions',
      editable: 'Editable',
    },
    actions: {
      delete: 'Delete',
      generateToken: 'Generate Token',
    },
    expiration: {
      default: 'Default',
    },
    filters: {
      editable: {
        label: 'Editable',
        isEditable: 'Editable',
        isNotEditable: 'Non-editable',
      },
    },
    permissions: {
      all: 'Full access',
    },
    editable: {
      yes: 'Yes',
      no: 'No',
    },
  },
  create: {
    title: 'Create API Key',
    error: 'Failed to create API key',
    unlimitedWarning: 'Unlimited tokens remain active until deleted. We recommend setting an expiration period.',
    tabs: {
      info: 'Info',
      permissions: 'Permissions',
    },
    expirationUnits: {
      minutes: 'Minutes',
      hours: 'Hours',
      days: 'Days',
      unlimited: 'Unlimited',
    },
    fields: {
      alias: 'Name',
      expiresAt: 'Session Expiration',
    },
  },
  newSecretModal: {
    title: 'New Secret Key',
    subtitle: 'Copy the secret key to clipboard and save it somewhere safe.',
    warning: "Please note: Once you close the window, you won't be able to view this secret key again.",
    secretKeyLabel: 'Secret Key',
    copy: 'Copy',
    copySuccess: 'Copied to clipboard',
    copyError: 'Failed to copy to clipboard',
    done: 'Done',
  },
  delete: {
    success: 'API key deleted',
    error: 'Failed to delete API key',
    confirmModal: {
      title: 'Delete API Key',
      body: 'Are you sure you want to delete "{{ alias }}"? All active tokens minted from this key will stop working immediately.',
      bodyMany:
        'Are you sure you want to delete {{ count }} API keys? All active tokens minted from these keys will stop working immediately.',
      confirm: 'Delete',
    },
  },
  edit: {
    title: 'Edit "{{ alias }}"',
    success: 'API key updated',
    error: 'Failed to update API key',
  },
  generateToken: {
    title: 'Enter Secret Key - {{ alias }}',
    subTitle: 'Enter the secret key and click on generate to create a token and a short code.',
    successTitle: 'New API Token & Short Code',
    submit: 'Generate',
    cancel: 'Cancel',
    done: 'Done',
    copy: 'Copy',
    copySuccess: 'Copied to clipboard',
    copyError: 'Failed to copy to clipboard',
    error: 'Failed to generate token',
    instructions: 'Paste your stored client secret to generate a new access token.',
    tokenWarning: `Please note: Once you close the window, you won't be able to view this token again.`,
    shortCodeWarning: `Please note: Once you close the window, you won't be able to view this short code again.`,
    fields: {
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'Paste your secret key',
      token: 'Access Token',
      shortCode: 'Short Code',
      expiration: 'Expiration',
      tokenInfo: 'Copy the token to clipboard and save it somewhere safe.',
      shortCodeInfo: 'Copy the short code to clipboard and save it somewhere safe.',
    },
  },
};

export default apiKeys;
